module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "press-5"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("连续型电子出版物核验进度")]), _vm._v(" "), _c('a', {
    staticClass: "downBtn",
    attrs: {
      "href": _vm.fileUrl,
      "download": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    }
  }, [_vm._v("下载封面和盖章页")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDat,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1 + 15 * (_vm.tabPost.no - 1)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "核验年度",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "year")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "核验出版物名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("strTrans")(scope.row, "pgstate")) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goDeep(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.tabPost.total > 1) ? _c('div', {
    staticClass: "pageArea"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tabPost.no,
      "layout": "prev, pager, next",
      "page-count": _vm.tabPost.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b16b2ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/SuccessivePart/examProgressHistory.vue
// module id = 1779
// module chunks = 1